import { AmcContractStatus } from "features/Amc/constants/amc-contract.constants";
import { WorkAssignmentStatus } from "features/WorkAssignments/constants/work-assignment.constants";
import type { Amc } from "features/Amc/types/amc.types";

/**
 * Cancel / complete require the actor to be an ASSIGNED assignee on the contract
 * (or a super admin) — mirrors the backend's assignment gate. Ready-for-activation
 * has no assignment requirement — it's permission-gated only.
 */
export function canActOnAmcContract(
  contract: Pick<Amc, "workAssignments">,
  isYou: (userId: number) => boolean,
  isSuperAdmin: boolean,
): boolean {
  if (isSuperAdmin) return true;
  return (contract.workAssignments ?? []).some(
    (a) =>
      a.status === WorkAssignmentStatus.ASSIGNED &&
      !a.deleted_at &&
      isYou(Number(a.toUserId)),
  );
}

export const AmcContractRules = {
  canMarkReadyForActivation: (status?: AmcContractStatus) =>
    status === AmcContractStatus.DRAFT,

  canCancel: (status?: AmcContractStatus) =>
    [AmcContractStatus.DRAFT, AmcContractStatus.READY_FOR_ACTIVATION].includes(
      status as AmcContractStatus,
    ),

  /** Complete is a single manual action, callable any time from ACTIVE — no end-date gating. */
  canComplete: (status?: AmcContractStatus) =>
    status === AmcContractStatus.ACTIVE,

  canEditNumberOfVisits: (status?: AmcContractStatus) =>
    [
      AmcContractStatus.DRAFT,
      AmcContractStatus.READY_FOR_ACTIVATION,
      AmcContractStatus.ACTIVE,
    ].includes(status as AmcContractStatus),

  canEditDates: (status?: AmcContractStatus) =>
    [AmcContractStatus.DRAFT, AmcContractStatus.READY_FOR_ACTIVATION].includes(
      status as AmcContractStatus,
    ),
  canEditClient: (status?: AmcContractStatus) =>
    [AmcContractStatus.DRAFT].includes(status as AmcContractStatus),
};
